module.exports = __webpack_public_path__ + "img/two1Green.5edd8867.jpg";